// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var SurveyForm$ReactHooksTemplate = require("./SurveyForm.res.js");

function reducer(param, action) {
  if (typeof action !== "object") {
    return "InvalidSurvey";
  } else {
    return {
            TAG: "Available",
            _0: action._0
          };
  }
}

function fetchSurvey(id) {
  var url = "/api/v1/surveys/" + id;
  return Js_promise.then_((function (json) {
                return Promise.resolve(Json_decode.field("survey", Survey$ReactHooksTemplate.fromJson, json));
              }), Http$ReactHooksTemplate.fetchGetJSON(url));
}

function SurveyEdit(props) {
  var id = props.id;
  var match = React.useReducer(reducer, "FetchingSurvey");
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.then_((function (survey) {
                  return Promise.resolve(Curry._1(dispatch, {
                                  TAG: "FetchedSurvey",
                                  _0: survey
                                }));
                }), fetchSurvey(id));
        }), []);
  if (typeof state !== "object") {
    if (state === "FetchingSurvey") {
      return JsxRuntime.jsx("p", {
                  children: "Loading Survey"
                });
    } else {
      return JsxRuntime.jsx("p", {
                  children: "Survey not found"
                });
    }
  } else {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(SurveyForm$ReactHooksTemplate.make, {
                      survey: state._0,
                      projectId: props.projectId,
                      featuresEnabled: props.featuresEnabled
                    })
              });
  }
}

var make = SurveyEdit;

exports.reducer = reducer;
exports.fetchSurvey = fetchSurvey;
exports.make = make;
/* react Not a pure module */
